export const defaultLang = 'vn'